import { BaseService } from "./baseservice";
import CookiesService from "./cookies.service"
import Swal from "sweetalert2";
import heapService from "./heap.service";

class AuthServiceClass extends BaseService {
    constructor() {
        super();
        this.user = false;
        this.level = 0;
        this.AUTH_COOKIE = ENVIRONMENT.AUTH_COOKIE;
        this.AUTH_TOKEN = ENVIRONMENT.AUTH_TOKEN;
        this.API_HOST = ENVIRONMENT.API_HOST;
    }

    canShow(section, organization_id) {
        if (section == "HR" && this.level >= 66) return true;

        if (!this.user || !this.user.permissions || !this.user.permissions[0]) return false;

        let result = false;

        this.user.permissions.map((permission) => {
            if (permission.section === section && permission.level > 0) {
                result = true;
            }
        });

        return result;
    }

    can(permission) {
        switch(permission) {
            case 'SET_HR_PERMISSIONS':
            case 'DELETE_SECTION':
            case 'RESTORE_SECTION':
            case 'DELETE_TEAM':
            case 'RESTORE_TEAM':
            case 'UNLOCK_KPI':
            case 'SHOW_WEEKDAY_SELECTOR':
            case 'GET_ALTERYX_CODES':
            case 'EXPORT_HR_ALL_PORTCOS':
            case 'IMPORT_HR_REPORTS':
            case 'SHOW_STAFFING_AGGREGATE':
            case 'EDIT_INSIGHT_METRICS':
            case 'ACCESS_INTERNAL_RIVERSIDE':
                return this.level >= 66; // Managing Director
                break;

            case 'ADD_KPI':
            case 'ADD_EMPLOYEE':
            case 'ADD_CANDIDATE':
            case 'ADD_STAFF':
            case 'ADD_CENSUS':
            case 'EDIT_EMPLOYEE':
            case 'EDIT_KPI':
            case 'EDIT_TEAM':
            case 'EDIT_SECTION':
            case 'EDIT_CELL':
            case 'EDIT_CANDIDATE':
            case 'EDIT_STAFF':
            case 'ANNOTATE_KPI':
            case 'DELETE_EMPLOYEE':
            case 'DELETE_KPI':
            case 'SE_EDITABLE_METRICS':
                return this.level >= 33; // Facilitator
                break;

            default:
                return false;
        }
    }

    login(user) {
        return this.fetch('POST', '/loginOauth', user);
    }

    async logout() {
        const cookie = CookiesService.get(this.AUTH_COOKIE);
        const token = localStorage.getItem(this.AUTH_TOKEN);
        localStorage.setItem(this.AUTH_TOKEN, '');

        if (cookie) {
            CookiesService.set(this.AUTH_COOKIE,'',365);
        }

        if ((token && token.length > 100) || (cookie && cookie.length > 100)) {
            try {
                await this.fetch('GET', '/logout');
            } catch(error) {
                console.log(error);
            }
        }

        if (ENVIRONMENT.DEBUG !== 'true') {
            window.location = this.API_HOST + '/external-login';
        } else if (!window.location.href.includes('login')) {
            window.location = '/login';
        }
    }

    getUser() {
        return this.user;
    }

    async init() {
        let response = false;

        try {
            response = await this.fetch('GET', '/me');
        } catch(e) {
            this.logout();
        } finally {
            if (response && response.data && response.data.user) {
                this.user = response.data.user;
                this.user.permissions = response.data.permissions;
                this.level = 0;

                const roles = {
                    sales: {
                        RMCFAdmin: 1,
                        Facilitator: 33,
                        ManagingDirector: 66,
                        SuperAdmin: 99
                    },
                    operations: {
                        isRiversideOpsAdmin: 1,
                        isRiversideOpsKPIsUser: 33,
                        isRiversideOpsExecutive: 66,
                        SuperAdmin: 99
                    }
                }

                const kpisType =  ENVIRONMENT.IS_OPERATIONS_KPIS ? 'operations' : 'sales';
                if ( this.user.roles ) {
                    Object.keys(roles[kpisType]).map( role =>  {
                        if (this.user.roles.includes(role))
                            this.level = roles[kpisType][role];
                    });
                }
            } else {
                this.logout();
            }

            if (this.level === 0) this.showRoleMessage();
            else this.sendHeapUserData(response.data.rras_data);
        }
    }

    showRoleMessage() {
        if (window.location.href.includes('login') || window.location.href.includes('logout')) return;

        document.getElementById('main-div').classList.add('blur')
        const APP_NAME = ENVIRONMENT.IS_OPERATIONS_KPIS ? 'ROAS' : 'Sales';

        Swal.fire({
            icon: 'warning',
            title: 'Oops',
            text: `Looks like you don't have access to the ${APP_NAME} KPIs application. 
                Please contact the Riverside RevOps team.`,
            confirmButtonText: 'Login',
        }).then((result) => {
            location.href = "/logout";
        })
    }

    /**
     * Save user data for Heap service.
    */
    sendHeapUserData(rrasData) {
        heapService.setData(rrasData);
    }
}

let AuthService = new AuthServiceClass();
export default AuthService;
